/**
 * Shared style constants for filter components in the Grading Portal.
 * These ensure consistent height and appearance across all filter inputs.
 */

// Common height for all filter inputs
export const FILTER_HEIGHT = 40;

// Common styling for outlined inputs with fixed padding and label centering
export const OUTLINED_INPUT_SX = {
    '& .MuiInputBase-root': {
        minHeight: FILTER_HEIGHT,
        height: 'auto', // Allow height to grow for chip wrapping
    },
    '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.23)' },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.87)' },
    // Suppress .front-royal-form-container border styles and fix padding
    '& input': {
        border: 'none !important',
        boxShadow: 'none !important',
    },
    // Hide number input spinners to prevent overlap with floating label
    '& input[type=number]': {
        MozAppearance: 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
    },
    '& select': {
        border: 'none !important',
        boxShadow: 'none !important',
    },
    // Fix floating label positioning when shrunk
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
        transform: 'translate(8px, -9px) scale(0.75)',
        transformOrigin: 'top left',
    },
};

// Styling for Autocomplete components to match Select height
export const AUTOCOMPLETE_SX = {
    ...OUTLINED_INPUT_SX,
    // Force consistent height on the OutlinedInput wrapper
    '& .MuiOutlinedInput-root': {
        minHeight: `${FILTER_HEIGHT}px !important`,
        height: 'auto',
        padding: '6.5px 39px 6.5px 9px !important', // Match Select vertical padding (8.5px content + border)
        alignItems: 'center',
    },
    // Compact the input field itself - THIS IS CRITICAL for height consistency
    '& .MuiAutocomplete-input': {
        padding: '0 !important', // Remove all input padding
        minWidth: '30px !important',
        height: '23px !important', // Match line-height of Select
        lineHeight: '23px !important',
    },
    // Make the endAdornment (dropdown icon) position correctly
    '& .MuiAutocomplete-endAdornment': {
        right: '9px !important',
    },
};

// Styling for TextField components to match Select height
export const TEXT_FIELD_SX = {
    ...OUTLINED_INPUT_SX,
    '& .MuiInputBase-root': {
        minHeight: FILTER_HEIGHT,
        height: FILTER_HEIGHT,
    },
    '& .MuiInputBase-input': {
        padding: '8.5px 14px !important',
    },
};

// Styling for multi-select components with flexible width
export const MULTI_SELECT_SX = {
    minWidth: 180,
    maxWidth: 350,
    ...OUTLINED_INPUT_SX,
    '& .MuiSelect-select': {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '4px',
        paddingTop: '6px',
        paddingBottom: '6px',
    },
};
